export default {

    props: ['initialTab'],

    mounted: function() {
        if (!this.initialTab) {
            return;
        }

        this.currentTab = this.initialTab;
    },

    data: () => {
        return {
            currentTab: 0,
        }
    },
}
